"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue } from "vue-property-decorator";
import { APIDataSource } from "@/components/grid/data-source";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
import _ from "lodash";
let MultiImportMembers = class extends Vue {
  constructor() {
    super(...arguments);
    this.activestep = 0;
    this.importMode = "edit_vd";
    this.importTitle = this.$t("multiimportmembers.batch_modification");
    this.errorMessage = null;
    this.errorTimeout = null;
    this.errorNum = 0;
    this.session_id = null;
    this.dialog = new UiDialogController();
    // control:any | GridController = new GridController<VdBatchAddModel>(new APIDataSource(`api://base.auth/api/v5/virtual_desktops/import/edit/list`));
    this.control = null;
    // create_shop_control:GridController = new GridController<ShopBatchAddModel>(new APIDataSource(`api://base.auth/api/v5/shops/import/add/list`));
    this.create_shop_control = null;
    // edit_shop_control:GridController = new GridController<ShopBatchEditModel>(new APIDataSource(`api://base.auth/api/v5/shops/import/edit/list`));
    this.edit_shop_control = null;
    this.upload_num_vd_edit = 0;
    this.upload_num_shop_create = 0;
    this.upload_num_shop_edit = 0;
    this.downloadmodel = _.debounce(() => __async(this, null, function* () {
      this.downloadrenewtable();
    }), 800);
  }
  mounted() {
  }
  open(model) {
    return __async(this, null, function* () {
      this.importMode = model;
      if (this.importMode === "edit_vd") {
        this.importTitle = this.$t(
          "multiimportmembers.batch_modification"
        );
      }
      if (this.importMode === "edit_shop") {
        this.importTitle = this.$t(
          "multiimportmembers.batch_modification_of_stores"
        );
      }
      if (this.importMode === "create_shop") {
        this.importTitle = this.$t("multiimportmembers.import_store");
      }
      this.dialog.visible = true;
    });
  }
  continueUpload() {
    return __async(this, null, function* () {
      try {
        this.activestep = 2;
        if (this.importMode === "edit_vd") {
          yield API.put(
            `api://base.auth.pro/v1/virtual-desktop-edit-excel/${this.session_id}`
          );
          yield this.control.search();
          this.upload_num_vd_edit = 0;
          for (let item of this.control.result.datas) {
            if (item.errors.length === 0) {
              this.upload_num_vd_edit += 1;
            }
          }
        }
        if (this.importMode === "create_shop") {
          const response = yield API.post(`api://base.auth.pro/v1/shops`, {
            model: "shop.from.excel",
            ignoreErrors: true,
            importFileId: this.session_id
          });
          this.upload_num_shop_create = response.data.total;
        }
        if (this.importMode === "edit_shop") {
          const response = yield API.put(`api://base.auth.pro/v1/shops`, {
            model: "shop.batch.edit.from.excel",
            ignoreErrors: true,
            importFileId: this.session_id
          });
          this.upload_num_shop_edit = response.data.total;
        }
        this.activestep = 3;
      } catch (error) {
        this.activestep = 1;
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  ConfirmUpload() {
    return __async(this, null, function* () {
      try {
        this.activestep = 2;
        if (this.importMode === "edit_vd") {
          yield API.put(
            `api://base.auth.pro/v1/virtual-desktop-edit-excel/${this.session_id}`
          );
          this.upload_num_vd_edit = 0;
          for (let item of this.control.result.datas) {
            if (item.errors.length === 0) {
              this.upload_num_vd_edit += 1;
            }
          }
        }
        if (this.importMode === "create_shop") {
          const response = yield API.post(`api://base.auth.pro/v1/shops`, {
            model: "shop.from.excel",
            ignoreErrors: false,
            importFileId: this.session_id
          });
          this.upload_num_shop_create = response.data.total;
        }
        if (this.importMode === "edit_shop") {
          const response = yield API.put(`api://base.auth.pro/v1/shops`, {
            model: "shop.batch.edit.from.excel",
            ignoreErrors: false,
            importFileId: this.session_id
          });
          this.upload_num_shop_edit = response.data.total;
        }
        this.activestep = 3;
      } catch (error) {
        this.activestep = 1;
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  uploadComplete() {
    this.dialog.visible = false;
    this.reupload();
    this.$emit("success");
  }
  reupload() {
    this.activestep = 0;
    this.errorNum = 0;
    this.session_id = null;
  }
  downloadrenewtable() {
    return __async(this, null, function* () {
      try {
        if (this.importMode === "edit_vd") {
          this.$message.success(
            this.$t(
              "multiimportmembers.getting_the_download_link_starting_the_download_later"
            )
          );
          const response = yield API.post(
            `api://base.auth.pro/v1/virtual-desktop-edit-excel`,
            {
              ids: ((selectItems) => {
                let _items = [];
                for (let _item of selectItems) {
                  _items.push(_item.id);
                }
                return _items;
              })(this.items)
            }
          );
          fetch(response.data.url).then((response2) => response2.blob()).then((blob) => {
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.download = response.data.title;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
          });
        }
        if (this.importMode === "create_shop") {
          this.$message.success(
            this.$t(
              "multiimportmembers.getting_the_download_link_starting_the_download_later"
            )
          );
          let downloadWin = window.open("", "_self");
          let response = yield API.post(`api://base.auth.pro/v1/shops/import/template`);
          downloadWin.location.href = response.data.downloadUrl;
        }
        if (this.importMode === "edit_shop") {
          this.$message.success(
            this.$t(
              "multiimportmembers.getting_the_download_link_starting_the_download_later"
            )
          );
          let downloadWin = window.open("", "_self");
          let response = yield API.post(
            `api://base.auth.pro/v1/shops-edit-excels`,
            {
              ids: ((selectItems) => {
                let _items = [];
                for (let _item of selectItems) {
                  _items.push(_item.id);
                }
                return _items;
              })(this.items)
            }
          );
          downloadWin.location.href = response.data.downloadUrl;
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  elInFile(file) {
    return __async(this, null, function* () {
      try {
        this.errorMessage = null;
        clearTimeout(this.errorTimeout);
        if (this.importMode === "edit_vd") {
          if (file.name.indexOf(".xlsx") === -1) {
            this.errorMessage = this.$t(
              "multiimportmembers.upload_file_format_must_be"
            );
            this.errorTimeout = setTimeout(() => {
              this.errorMessage = null;
            }, 5e3);
            return;
          }
          const formdata = new window.FormData();
          formdata.append("file", file.raw);
          let response = yield API.put(
            `api://base.auth.pro/v1/virtual-desktop-edit-excel`,
            formdata
          );
          let _url = response.data.url;
          this.session_id = _url.toString().split("virtual-desktop-edit-excel/")[1];
          this.control = new GridController(
            new APIDataSource(
              `api://base.auth.pro/v1/virtual-desktop-edit-excel/${this.session_id}`
            )
          );
          this.control.pagePosition = "dialog";
          this.control.query.sort = "createdTime,desc";
          yield this.control.search();
          for (let item of this.control.result.datas) {
            if (item.errors.length > 0) {
              this.errorNum += 1;
            }
          }
          this.activestep = 1;
          return;
        }
        if (this.importMode === "create_shop") {
          if (file.name.indexOf(".xlsx") === -1) {
            this.errorMessage = this.$t(
              "multiimportmembers.upload_file_format_must_be"
            );
            this.errorTimeout = setTimeout(() => {
              this.errorMessage = null;
            }, 5e3);
            return;
          }
          const formdata = new window.FormData();
          formdata.append("file", file.raw);
          let response = yield API.post(
            `api://base.auth.pro/v1/shops-import-excels`,
            formdata
          );
          this.session_id = response.data.importFileId;
          this.create_shop_control = new GridController(
            new APIDataSource(
              `api://base.auth.pro/v1/shops-from-excels/${this.session_id}`
            )
          );
          this.create_shop_control.pagePosition = "dialog";
          this.create_shop_control.query.sort = "createdTime,desc";
          yield this.create_shop_control.search();
          for (let item of this.create_shop_control.result.datas) {
            if (item.errors.length > 0) {
              this.errorNum += 1;
            }
          }
          this.activestep = 1;
          return;
        }
        if (this.importMode === "edit_shop") {
          if (file.name.indexOf(".xlsx") === -1) {
            this.errorMessage = this.$t(
              "multiimportmembers.upload_file_format_must_be"
            );
            this.errorTimeout = setTimeout(() => {
              this.errorMessage = null;
            }, 5e3);
            return;
          }
          const formdata = new window.FormData();
          formdata.append("file", file.raw);
          let response = yield API.post(
            `api://base.auth.pro/v1/shops-edit-excels/import`,
            formdata
          );
          this.session_id = response.data.importFileId;
          this.edit_shop_control = new GridController(
            new APIDataSource(
              `api://base.auth.pro/v1/shops-edit-from-excels/${this.session_id}`
            )
          );
          this.edit_shop_control.pagePosition = "dialog";
          this.edit_shop_control.query.sort = "createdTime,desc";
          yield this.edit_shop_control.search();
          for (let item of this.edit_shop_control.result.datas) {
            if (item.errors.length > 0) {
              this.errorNum += 1;
            }
          }
          this.activestep = 1;
          return;
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  PropSync("selectitems", {
    type: Array,
    default: () => {
      return new Array();
    }
  })
], MultiImportMembers.prototype, "items", 2);
MultiImportMembers = __decorateClass([
  Component({
    components: {
      UiGrid,
      UiDialog
    }
  })
], MultiImportMembers);
export {
  MultiImportMembers as default
};
